import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when a system landscape already contains systems
 */
export class SystemLandscapeInUseError extends RESTError {}
